// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__hu6as","author":"Table_author__dBry6","authorImage":"Table_authorImage__3X3Bw","unreadRow":"Table_unreadRow__tnfan"};